var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-monolith"},[_c('h2',{staticClass:"product-desc__title--fixed"},[_vm._v("Возможности персонализации")]),_c('Monolith')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }